export default __webpack_public_path__ + "static/media/Capture3.3fbcb52a.JPG";